import Distritos from "./layers/Distritos";
import Macrozonas from "./layers/Macrozonas";
import Provincias from "./layers/Provincias";
import Zeodh from "./layers/Zeodh";
import Zat from "./layers/Zat";

const Perimeters = {
    idSection: "perimeters",
    treeviews: {
        title: "Mobility Indicators Content.sections.Perimeters",
        layers: {
            checked: 1,
            expand: true,
        },
    },
    layers: {
        distritos: Distritos,
        macrozonas: Macrozonas,
        provincias: Provincias,
        zat: Zat,
        zeodh: Zeodh,
    },
};

export default Perimeters;
